import React, { Fragment } from "react";

import { Mobile, NotMobile } from "../../../../../../hocs/Responsive";
import { TabList } from "../../../../../../components/tabList";
import { HorizontalScrollTabs } from "../../../../../../components/horizontalScrollTabs/HorizontalScrollTabs";
import { useTabsContext } from "./TabsContext";

export const TableTabs = () => {
  const { tabs, selectedTab, onSelectedChange } = useTabsContext();

  return (
    <Fragment>
      <NotMobile>
        <TabList
          items={tabs}
          selected={selectedTab}
          onClick={onSelectedChange}
        />
      </NotMobile>
      <Mobile>
        <HorizontalScrollTabs
          tabs={tabs}
          selected={selectedTab}
          onClick={onSelectedChange}
        />
      </Mobile>
    </Fragment>
  );
};
